import { CLAccount } from '../client';
import { SLEntity } from './entity';

export type SLAuthorizationType = 'FULL';

interface CreateSLAuthorizationInput {
  account: string
  entity: string
  type: SLAuthorizationType
}

export class SLAuthorization {
  id: string
  account: CLAccount
  entity: SLEntity
  type: SLAuthorizationType
  createdAt: number
  updatedAt: number

  constructor(data: any = {}) {
    Object.assign(this, data);

    if (this.account) {
      this.account = new CLAccount(this.account);
    }

    if (this.entity) {
      this.entity = new SLEntity(this.entity);
    }
  }

  get valid():boolean {
    if(!this.account) {
      return false;
    }

    if(!this.entity) {
      return false;
    }

    if(!this.type) {
      return false;
    }

    return true;
  }

  toCreateSLAuthorizationInput(): CreateSLAuthorizationInput {
    return {
      account: this.account.id,
      entity: this.entity.id,
      type: this.type,
    };
  }
}
